import React, { useState, useEffect, useCallback } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.85)",
  zIndex: 1400,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

const closeButtonStyle = {
  position: "absolute",
  top: 16,
  right: 16,
  color: "#fff",
  backgroundColor: "rgba(0,0,0,0.5)",
};

const navButtonStyle = {
  color: "#fff",
  backgroundColor: "rgba(0,0,0,0.5)",
  margin: "0 12px",
};

const imageContainerStyle = {
  maxWidth: "80vw",
  maxHeight: "75vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const imageStyle = {
  maxWidth: "100%",
  maxHeight: "75vh",
  objectFit: "contain",
  borderRadius: "8px",
  border: "2px solid rgba(255,255,255,0.3)",
};

const counterStyle = {
  color: "#fff",
  fontSize: "14px",
  marginTop: "12px",
};

function ImageViewer({ open, images, initialIndex, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  useEffect(() => {
    setCurrentIndex(initialIndex || 0);
  }, [initialIndex, open]);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  }, [images]);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  }, [images]);

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") handlePrev();
      if (e.key === "ArrowRight") handleNext();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose, handlePrev, handleNext]);

  if (!open || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];
  const imageSrc = currentImage.pictureBase64 || currentImage.pictureUrl;

  return (
    <div style={overlayStyle} onClick={onClose}>
      <IconButton style={closeButtonStyle} onClick={onClose}>
        <CloseIcon fontSize="large" />
      </IconButton>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton style={navButtonStyle} onClick={handlePrev}>
          <ChevronLeftIcon fontSize="large" />
        </IconButton>

        <div style={imageContainerStyle}>
          <img
            src={imageSrc}
            alt={currentImage.pictureName || `Image ${currentIndex + 1}`}
            style={imageStyle}
          />
        </div>

        <IconButton style={navButtonStyle} onClick={handleNext}>
          <ChevronRightIcon fontSize="large" />
        </IconButton>
      </Box>

      <div style={counterStyle}>
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  );
}

export default ImageViewer;
